import { render, staticRenderFns } from "./payment-status-change.dialog.vue?vue&type=template&id=3561ddfa&scoped=true"
import script from "./payment-status-change.dialog.vue?vue&type=script&lang=js"
export * from "./payment-status-change.dialog.vue?vue&type=script&lang=js"
import style0 from "./payment-status-change.dialog.vue?vue&type=style&index=0&id=3561ddfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3561ddfa",
  null
  
)

export default component.exports